export default "__VITE_ASSET__CHjtJ3iV__"